module.exports = __webpack_public_path__ + "static/grillo-26bdad7496e41b525353881e8d288825.jpg";